<template>
  <v-navigation-drawer dark absolute expand-on-hover permanent right>
    <v-list dense>
      <v-list-item @click="loadSummary('collated')">
        <v-list-item-icon>
          <v-icon>mdi-image-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Moodboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item @click="loadSummary('images')">
        <v-list-item-icon>
          <v-icon>mdi-poll</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Images</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item @click="loadSummary('words')">
        <v-list-item-icon>
          <v-icon>mdi-book-alphabet</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Words</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Responses</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-for="doc in users">
        <v-list-item @click="loadDoc(doc)" :key="doc">
          <v-list-item-content>
            <v-list-item-title><span>{{ doc }} </span></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "ResultsTilesBar",
  props: {
    doc: {
      type: Object,
    },
    users: {
      type: Array
    }
  },
  computed: {
    filteredUsers() {
      // return this.doc ? this.doc.users.filter(item => item.webrole == 'user') : null
      return this.doc.users;
    },
  },
  methods: {
    loadDoc(val) {
      this.$emit("loadDoc", val);
    },
    loadSummary(val) {
      this.$emit("loadSummary", val);
    },
  },
};
</script>
